import { render, staticRenderFns } from "./MarginKpiPopup.vue?vue&type=template&id=544caf8e&scoped=true&"
import script from "./MarginKpiPopup.vue?vue&type=script&lang=js&"
export * from "./MarginKpiPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarginKpiPopup.vue?vue&type=style&index=0&id=544caf8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544caf8e",
  null
  
)

export default component.exports